import React from 'react';
import { utils } from '../utils';
import DomSanitizer from 'xss';
export default function mobileZoomText(props) {
    var item = props.item, currentWindow = props.currentWindow;
    var maxWidth = item.maxWidth, maxHeight = item.maxHeight, bgColor = item.bgColor, html = item.html;
    var isLandscape = window.innerWidth > window.innerHeight;
    var screenHeight = window.screen.height;
    var screenWidth = window.screen.width;
    var ratio = screenWidth / screenHeight;
    var cutByHeight = ratio > item.ratio;
    if (isLandscape && utils.isiOS()) {
        cutByHeight = !cutByHeight;
    }
    var scale = cutByHeight
        ? currentWindow.height / maxHeight
        : currentWindow.width / maxWidth;
    return (React.createElement("div", { className: 'fullscreen-content  fullscreen-item-visible fullscreen-item gallery-item-loaded pro-fullscreen-text-item', style: {
            width: maxWidth,
            height: maxHeight,
            transform: "translate3d(-50%, -50%, 0) scale(".concat(scale, ")"),
            background: bgColor,
        }, key: 'text', "aria-label": "text item", dangerouslySetInnerHTML: { __html: DomSanitizer(html) } }));
}
//# sourceMappingURL=mobileZoomText.js.map